import { useContext } from 'react';
import { OnboardingContext } from '../components/OnboardingFlowProvider';
import { OnboardingContextType } from '../types/onboarding';

/**
 * Custom hook to use the onboarding flow context
 * @returns The onboarding context value
 */
export const useOnboardingFlow = (): OnboardingContextType => {
  const context = useContext(OnboardingContext);
  
  if (context === undefined) {
    throw new Error('useOnboardingFlow must be used within an OnboardingFlowProvider');
  }
  
  return context;
};

export default useOnboardingFlow;
